import { useQuery } from "@tanstack/react-query";
import { Wand2, RefreshCw } from "lucide-react";
import { gradeSuggestion } from "@/lib/adminApi";

const TONE = { win: "border-[#00E676]/50 bg-[#00E676]/10 text-[#00E676]", loss: "border-[#EF4444]/50 bg-[#EF4444]/10 text-[#EF4444]", push: "border-slate-400/40 bg-slate-400/10 text-slate-300", void: "border-slate-400/40 bg-slate-400/10 text-slate-300" };

export function GradeSuggestion({ pick, onApply, applying }) {
  const eligible = pick.player_id && pick.prop_market && pick.prop_line != null && pick.event_start_utc && new Date(pick.event_start_utc) < new Date();
  const { data, isFetching, refetch } = useQuery({ queryKey: ["grade", pick.id], queryFn: () => gradeSuggestion(pick.id), enabled: !!eligible, staleTime: 120_000 });
  if (!eligible) return null;
  return (
    <div className="mb-2 flex w-full flex-wrap items-center gap-2 rounded-md border border-[#1E2738] bg-[#0A0D14] px-3 py-2" data-testid={`grade-suggestion-${pick.id}`}>
      <Wand2 size={12} className="text-[#00E676]" />
      <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">Auto-grade</span>
      {isFetching && !data ? <span className="font-mono text-[11px] text-slate-400">Reading box score…</span>
        : data?.available ? (
          <>
            <span className={`tag border ${TONE[data.suggested]}`} data-testid={`grade-suggested-${pick.id}`}>Suggested: {data.suggested}</span>
            <span className="font-mono text-[11px] text-slate-300">{data.reason}</span>
            {data.box && <span className="font-mono text-[10px] text-slate-500">{data.box.pts} pts · {data.box.reb} reb · {data.box.ast} ast · {data.box.fg3m} 3pm · {data.box.min} min</span>}
            <button data-testid={`grade-apply-${pick.id}`} disabled={applying} onClick={() => onApply(data.suggested, { source: "balldontlie", value: data.value, line: data.line, side: data.side, market: data.market_label, box: data.box, game_id: data.game?.id, computed_at: data.computed_at })} className="btn-primary ml-auto !px-3 !py-1 text-[11px]">Apply {data.suggested}</button>
          </>
        ) : (
          <>
            <span className="font-mono text-[11px] text-[#F59E0B]" data-testid={`grade-reason-${pick.id}`}>{data?.reason || "Unavailable"}</span>
            <button onClick={() => refetch()} className="ml-auto rounded-md border border-[#2A364F] p-1 text-slate-400 hover:text-white" title="Re-check"><RefreshCw size={12} /></button>
          </>
        )}
    </div>
  );
}
